import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Protected route wrapper component
 * Restricts access based on authentication and special user status
 */
const ProtectedRoute = ({ children, requireSpecialUser = false }) => {
  const { currentUser, isSpecialUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to home if special user access is required but user doesn't have it
  if (requireSpecialUser && !isSpecialUser) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
